import React from 'react';
import { ContractRefreshProvider } from '../../../contexts/ContractRefreshContext';
import ContractProfileLayout from './ContractProfileLayout';

interface ContractProfileLayoutWrapperProps {
  children: React.ReactNode;
  isLoading?: boolean;
}

const ContractProfileLayoutWrapper: React.FC<ContractProfileLayoutWrapperProps> = ({ children, isLoading }) => {
  return (
    <ContractRefreshProvider>
      <ContractProfileLayout isLoading={isLoading}>
        {children}
      </ContractProfileLayout>
    </ContractRefreshProvider>
  );
};

export default ContractProfileLayoutWrapper;